import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ImageLightbox({ item, onClose, onPrev, onNext, showNav = false }) {
  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (showNav && e.key === "ArrowLeft" && onPrev) onPrev();
      if (showNav && e.key === "ArrowRight" && onNext) onNext();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [item, onClose, onPrev, onNext, showNav]);

  return (
    <AnimatePresence>
      {item ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/95 p-4 backdrop-blur-xl sm:p-8"
          onClick={onClose}
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
        >
          <button
            type="button"
            className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-xl text-white transition hover:bg-white/20 sm:right-8 sm:top-8"
            onClick={onClose}
            aria-label="Close preview"
          >
            ✕
          </button>

          {showNav && onPrev ? (
            <button
              type="button"
              className="absolute left-4 top-1/2 z-10 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 bg-white/10 text-2xl text-white transition hover:bg-white/20 sm:flex"
              onClick={(e) => {
                e.stopPropagation();
                onPrev();
              }}
              aria-label="Previous project"
            >
              ‹
            </button>
          ) : null}

          {showNav && onNext ? (
            <button
              type="button"
              className="absolute right-4 top-1/2 z-10 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 bg-white/10 text-2xl text-white transition hover:bg-white/20 sm:right-16 sm:flex"
              onClick={(e) => {
                e.stopPropagation();
                onNext();
              }}
              aria-label="Next project"
            >
              ›
            </button>
          ) : null}

          <motion.div
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.92, opacity: 0 }}
            className="flex max-h-[90vh] w-full max-w-6xl flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={item.image}
              alt=""
              className="max-h-[75vh] w-full rounded-2xl border border-white/10 object-contain shadow-2xl"
            />
            <motion.div
              initial={{ y: 12, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              className="mt-5 flex justify-center px-1"
            >
              <button
                type="button"
                onClick={onClose}
                className="rounded-full border border-white/20 px-5 py-2 font-sans text-sm text-white/80 transition hover:border-white/40 hover:text-white"
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
